enum EnvType {
  production = 'production',
  beta = 'beta',
  test = 'test',
  preprod = 'preprod',
  localhost = 'localhost'
}

export const APP_URL = process.env.NEXT_PUBLIC_HOME_URL

//preprod is used in gitlab ci pipeline.
// I'm not sure can i change it.
// We don't use 'preprod' in application, but I let this value in enum to be aware of it.
export const getEnv = (): EnvType | '' => {
  const ENV = process.env.NEXT_PUBLIC_ENV as EnvType | undefined

  return ENV || EnvType.localhost
}

const env = getEnv()

export const isProd = env === EnvType.production
export const isBeta = env === EnvType.beta
export const isDev = env === EnvType.test
